import type { CharacterSummaryDTO, MeResponse, RealmDTO } from '@jianghu/protocol';
import { create } from 'zustand';

export type Screen = 'loading' | 'auth' | 'menu' | 'realms' | 'characters' | 'create' | 'game';

interface SessionState {
  screen: Screen;
  user: MeResponse['user'] | null;
  realm: RealmDTO | null;
  character: CharacterSummaryDTO | null;
  go(screen: Screen): void;
  setUser(user: MeResponse['user'] | null): void;
  setRealm(realm: RealmDTO | null): void;
  setCharacter(c: CharacterSummaryDTO | null): void;
}

const REALM_KEY = 'jh.realm';

export const useSession = create<SessionState>((set) => ({
  screen: 'loading',
  user: null,
  realm: null,
  character: null,
  go: (screen) => set({ screen }),
  setUser: (user) => set({ user }),
  setRealm: (realm) => {
    try {
      if (realm) localStorage.setItem(REALM_KEY, realm.id);
    } catch {
      /* storage unavailable */
    }
    set({ realm });
  },
  setCharacter: (character) => set({ character }),
}));

export function rememberedRealmId(): string | null {
  try {
    return localStorage.getItem(REALM_KEY);
  } catch {
    return null;
  }
}
